export default {
  companyFeedSettingsMetadata: {
    successSet: 'Список вопросов для ленты успешно сохранён',
    errorGet: 'Не удалось получить список вопросов для ленты',
    errorSet: 'Не удалось сохранить список вопросов для ленты',
    noFeedSettings:
      'В ленту ещё не было добавлено ни одного вопроса. Чтобы добавить вопрос, создайте опрос на вкладке «Опросы» и добавьте в него вопрос с включённой настройкой «отображать в ленте»',
    creationDate: 'Дата создания',
    nameQuestion: 'Название вопроса',
    surveyDate: 'Дата опроса',
    deleteQuestionsButton: 'Удалить выбранные вопросы из ленты',
    deleteQuestionsTitle: 'Удалить вопросы из ленты?',
    deleteQuestionsText: 'Отменить данное действие будет невозможно',
    successDeleteQuestions: 'Вопросы успешно удалены',
    errorDeleteQuestions: 'Не удалось удалить вопросы',
  },
};
